<template>
	<div>
		<template v-if="datos.tipo === 'barras'">
			<chartjs-bar
				:beginatzero="true"
				:label="datos.titulo"
				:height="200"
				:labels="datos.labels"
				:datasets="datos.datasets"
				>
			</chartjs-bar>
		</template>
		<template v-if="datos.tipo === 'lineas'">
			<chartjs-line
				:beginatzero="true"
				:label="datos.titulo"
				:height="200"
				:labels="datos.labels"
				:datasets="datos.datasets"
				>
			</chartjs-line>
		</template>
		<template v-if="datos.tipo === 'queso'">
			<chartjs-pie
				v-bind:option="{}"
				:datalabel="datos.titulo"
				:height="200"
				:labels="datos.labels"
				:data="datos.data"
				>
			</chartjs-pie>
		</template>

		<!-- AHORA LA TABLA CON LOS DATOS -->
		<div class="table-responsive">
			<table class="table table-striped table-condensed">
				<thead>
					<tr>
						<th></th>
						<th v-for="set in datos.datasets" :key="set.label">
							{{set.label}}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(label, indexLabel) in datos.labels" :key="label">
						<td>
							{{label}}
						</td>
						<td v-for="(set, indexSet) in datos.datasets" :key="indexSet+'_'+set.label">
							{{set.data[indexLabel] | currency('')}} €
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	props: ['datos']
}
</script>



// WEBPACK FOOTER //
// src/modulos/consultas-facturacion/vue/components/porAgente/representarDatos.vue